import * as actionTypes from './actionTypes';
import { jobTopService } from './services';

const fetchJobTopRequest = () => ({
  type: actionTypes.FETCH_JOB_TOP_REQUEST
});

const fetchJobTopSuccess = (data) => ({
  type: actionTypes.FETCH_JOB_TOP_SUCCESS,
  data
});

const fetchJobTopFailure = () => ({
  type: actionTypes.FETCH_JOB_TOP_FAILURE
});

export const fetchJobTop = (): Function => {
  return async dispatch => {
    dispatch(fetchJobTopRequest());
    try {
      const data = await jobTopService.get();
      dispatch(fetchJobTopSuccess(data));
    } catch (e) {
      dispatch(fetchJobTopFailure());
    }
  }
};
